class Top {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    } else if ($(".js-case-refs-slider").length > 0) {
      this.initCaseRefsSlider();
    }
  }
  event() {
    // 理由タブ: 「相続させる側 (親世代)も見る」ボタンでタブ2を表示
    $(".js-reason-tab-switch").on("click", function () {
      const index = $(this).data("tab-index");
      $(".p-top__reason-tab-btn").eq(index).trigger("click");
    });

    this.initCaseSlider();
    this.initCaseRefsSlider();
    this.initCaseListSlider();
    this.initSeminarSlider();
    this.initReasonMangaScroll();
  }

  /**
   * 漫画エリア: 「タテ読み」ヒント非表示／カスタムスクロールバー。
   * トラックの黄塗りは scrollTop/maxScroll を --scroll-progress（0〜1）で反映。
   * x-teleport 後に DOM に現れるため MutationObserver と alpine:initialized で再バインド。
   */
  initReasonMangaScroll() {
    const bound = new WeakSet();

    const bindOne = (scrollEl) => {
      if (bound.has(scrollEl)) {
        return;
      }

      const $scrollbar = $(scrollEl).next(".p-top__reason-manga-scrollbar");
      const $track = $scrollbar.find(".p-top__reason-manga-scrollbar-track");
      const $thumb = $scrollbar.find(".p-top__reason-manga-scrollbar-thumb");
      const trackEl = $track[0];
      const thumbEl = $thumb[0];
      const viewportEl = $(scrollEl).closest(
        ".p-top__reason-manga-viewport",
      )[0];

      if (!$scrollbar.length || !trackEl || !thumbEl || !viewportEl) {
        return;
      }

      bound.add(scrollEl);

      const MIN_THUMB = 20;

      function updateThumb() {
        const trackH = trackEl.clientHeight;
        const { scrollTop, scrollHeight, clientHeight } = scrollEl;

        if (scrollHeight <= clientHeight + 1 || trackH < 1) {
          $scrollbar.css("visibility", "hidden");
          trackEl.style.setProperty("--scroll-progress", "0");
          thumbEl.style.height = "0";
          thumbEl.style.top = "0";
          return;
        }

        $scrollbar.css("visibility", "visible");
        const thumbH = Math.max(
          (clientHeight / scrollHeight) * trackH,
          MIN_THUMB,
        );
        const maxScroll = scrollHeight - clientHeight;
        const maxThumbTop = trackH - thumbH;
        const thumbTop =
          maxScroll > 0 ? (scrollTop / maxScroll) * maxThumbTop : 0;
        const scrollProgress = maxScroll > 0 ? scrollTop / maxScroll : 0;

        trackEl.style.setProperty("--scroll-progress", String(scrollProgress));
        thumbEl.style.height = `${thumbH}px`;
        thumbEl.style.top = `${thumbTop}px`;
      }

      $(scrollEl).on("scroll.reasonMangaSb", function () {
        if (this.scrollTop > 12) {
          $(this)
            .closest(".p-top__reason-manga-viewport")
            .addClass("is-scrolled");
        }
        updateThumb();
      });

      $(scrollEl)
        .find("img")
        .on("load.reasonMangaSb", function () {
          updateThumb();
        });

      if (typeof ResizeObserver !== "undefined") {
        const ro = new ResizeObserver(() => {
          updateThumb();
        });
        ro.observe(scrollEl);
        ro.observe(trackEl);
      }

      $(window).on("resize.reasonMangaSb", function () {
        updateThumb();
      });

      let dragStartY = 0;
      let dragStartScrollTop = 0;

      $thumb.on("pointerdown.reasonMangaSb", function (e) {
        e.preventDefault();
        dragStartY = e.clientY;
        dragStartScrollTop = scrollEl.scrollTop;
        thumbEl.setPointerCapture(e.pointerId);

        function onDrag(ev) {
          const trackH = trackEl.clientHeight;
          const { scrollHeight, clientHeight } = scrollEl;
          const thumbH = thumbEl.offsetHeight;
          const maxScroll = scrollHeight - clientHeight;
          const maxThumbTop = Math.max(trackH - thumbH, 0);
          if (maxScroll <= 0 || maxThumbTop <= 0) {
            return;
          }
          const deltaY = ev.clientY - dragStartY;
          scrollEl.scrollTop =
            dragStartScrollTop + (deltaY / maxThumbTop) * maxScroll;
        }

        function endDrag(ev) {
          try {
            thumbEl.releasePointerCapture(ev.pointerId);
          } catch (err) {
            /* noop */
          }
          $(thumbEl).off(
            "pointermove.reasonMangaSb pointerup.reasonMangaSb pointercancel.reasonMangaSb",
          );
        }

        $(thumbEl).on("pointermove.reasonMangaSb", onDrag);
        $(thumbEl).on(
          "pointerup.reasonMangaSb pointercancel.reasonMangaSb",
          endDrag,
        );
      });

      requestAnimationFrame(updateThumb);
    };

    const tryBindAll = () => {
      document
        .querySelectorAll(".js-reason-manga-scroll")
        .forEach((el) => bindOne(el));
    };

    tryBindAll();

    if (typeof MutationObserver !== "undefined") {
      const mo = new MutationObserver(() => {
        tryBindAll();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener("alpine:initialized", tryBindAll);
  }

  /**
   * 解決事例: PCは4件以上、SPは2件以上のときだけ Swiper。
   */
  initCaseSlider() {
    const $sliderEl = $(".p_top .js-case-slider");
    if (!$sliderEl.length || !$sliderEl.find(".swiper-slide").length) {
      return;
    }

    const sliderEl = $sliderEl[0];
    const $wrapper = $sliderEl.find(".swiper-wrapper");
    const $originalSlides = $wrapper.children(".swiper-slide").clone(true, true);
    const mq = window.matchMedia("(max-width: 767px)");
    let caseSwiper = null;

    const getActiveFilter = () => {
      return $(".js-case-filter-btn.is-active").data("case-filter") || "all";
    };

    const matchesFilter = (slide, filter) => {
      if (filter === "all") {
        return true;
      }

      const caseCats = String($(slide).data("case-cat") || "").split(/\s+/);
      return caseCats.includes(filter);
    };

    const destroyCaseSwiper = () => {
      if (caseSwiper) {
        caseSwiper.destroy(true, true);
        caseSwiper = null;
      }
    };

    const apply = () => {
      const filter = getActiveFilter();
      const $filteredSlides = $originalSlides
        .filter(function () {
          return matchesFilter(this, filter);
        })
        .clone(true, true);
      const slideCount = $filteredSlides.length;
      const shouldUseSwiper = mq.matches ? slideCount >= 2 : slideCount >= 4;
      const gridColumns = mq.matches ? 1 : Math.max(Math.min(slideCount, 3), 1);

      destroyCaseSwiper();
      $wrapper.empty().append($filteredSlides);
      sliderEl.style.setProperty("--case-grid-columns", gridColumns);

      if (!shouldUseSwiper || typeof Swiper === "undefined") {
        $sliderEl.removeClass("is-slider").addClass("is-grid");
        return;
      }

      $sliderEl.removeClass("is-grid").addClass("is-slider");

      caseSwiper = new Swiper(sliderEl, {
        slidesPerView: "auto",
        spaceBetween: 20,
        centeredSlides: true,
        watchOverflow: true,
        loop: true,
        simulateTouch: true,
        grabCursor: true,
        pagination: {
          el: $sliderEl.find(".swiper-pagination")[0],
          clickable: true,
        },
        navigation: {
          nextEl: $sliderEl.find(".swiper-button-next")[0],
          prevEl: $sliderEl.find(".swiper-button-prev")[0],
        },
        breakpoints: {
          768: {
            spaceBetween: 40,
          },
        },
      });
    };

    $(".js-case-filter-btn").on("click", function () {
      $(".js-case-filter-btn")
        .removeClass("is-active")
        .attr("aria-selected", "false");
      $(this).addClass("is-active").attr("aria-selected", "true");

      apply();
    });

    apply();

    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", apply);
    } else if (typeof mq.addListener === "function") {
      mq.addListener(apply);
    }
  }

  /**
   * 事例詳細: 参考画像が4枚以上のときの Swiper。
   */
  initCaseRefsSlider() {
    const $sliderEls = $(".js-case-refs-slider");
    if (!$sliderEls.length || typeof Swiper === "undefined") {
      return;
    }

    $sliderEls.each(function () {
      const sliderEl = this;
      const $sliderEl = $(sliderEl);
      const refsCount = Number($sliderEl.data("refs-count")) || 0;

      if (sliderEl.swiper || refsCount < 4) {
        return;
      }

      new Swiper(sliderEl, {
        slidesPerView: "auto",
        spaceBetween: 12,
        watchOverflow: true,
        loop: true,
        simulateTouch: true,
        grabCursor: true,
        pagination: {
          el: $sliderEl.find(".swiper-pagination")[0],
          clickable: true,
        },
        navigation: {
          nextEl: $sliderEl.find(".swiper-button-next")[0],
          prevEl: $sliderEl.find(".swiper-button-prev")[0],
        },
        breakpoints: {
          768: {
            spaceBetween: 16,
          },
        },
      });
    });
  }

  /**
   * 事例カード一覧: SPのみ Swiper。PCは CSS グリッド（_top.scss）で静的3列。
   */
  initCaseListSlider() {
    const $sliderEl = $(".p_top .js-case-list-slider");
    if (!$sliderEl.length || typeof Swiper === "undefined") {
      return;
    }

    const sliderEl = $sliderEl[0];
    let caseListSwiper = null;
    const mq = window.matchMedia("(max-width: 767px)");

    const apply = () => {
      if (mq.matches) {
        if (caseListSwiper) {
          return;
        }
        caseListSwiper = new Swiper(sliderEl, {
          slidesPerView: "auto",
          spaceBetween: 16,
          centeredSlides: true,
          watchOverflow: true,
          loop: true,
          pagination: {
            el: $sliderEl.find(".swiper-pagination")[0],
            clickable: true,
          },
          navigation: {
            nextEl: $sliderEl.find(".swiper-button-next")[0],
            prevEl: $sliderEl.find(".swiper-button-prev")[0],
          },
        });
      } else if (caseListSwiper) {
        caseListSwiper.destroy(true, true);
        caseListSwiper = null;
      }
    };

    apply();

    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", apply);
    } else if (typeof mq.addListener === "function") {
      mq.addListener(apply);
    }
  }

  /**
   * セミナー: SPのみ Swiper。PCは CSS グリッド（_top.scss）で静的3列。
   */
  initSeminarSlider() {
    const $sliderEl = $(".p_top .js-seminar-slider");
    if (!$sliderEl.length || typeof Swiper === "undefined") {
      return;
    }

    const sliderEl = $sliderEl[0];
    let seminarSwiper = null;
    const mq = window.matchMedia("(max-width: 767px)");

    const apply = () => {
      if (mq.matches) {
        if (seminarSwiper) {
          return;
        }
        seminarSwiper = new Swiper(sliderEl, {
          slidesPerView: "auto",
          spaceBetween: 16,
          centeredSlides: true,
          watchOverflow: true,
          loop: true,
          pagination: {
            el: $sliderEl.find(".swiper-pagination")[0],
            clickable: true,
          },
          navigation: {
            nextEl: $sliderEl.find(".swiper-button-next")[0],
            prevEl: $sliderEl.find(".swiper-button-prev")[0],
          },
        });
      } else if (seminarSwiper) {
        seminarSwiper.destroy(true, true);
        seminarSwiper = null;
      }
    };

    apply();

    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", apply);
    } else if (typeof mq.addListener === "function") {
      mq.addListener(apply);
    }
  }
}
